import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import Main from "../pages/client/Main.vue";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        // About 페이지
        path: "/about",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/About.vue"),
        props: true,
    },
    {
        // 이용약관
        path: "/terms",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/center/terms.vue"),
        props: true,
    },
    {
        // 이용약관
        path: "/terms",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/center/terms.vue"),
        props: true,
    },
    {
        // 개인정보처리방침
        path: "/privacy",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/center/privacy.vue"),
        props: true,
    },
    {
        // 이메일무단수집거부
        path: "/email-policy",
        component: () => import(/* webpackChunkName: "about" */ "../pages/client/center/email-policy.vue"),
        props: true,
    },
    {
        // 주거유형별 인테리어 리스트
        path: "/portfolio/resident",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/resident-list.vue"),
        props: true,
    },
    {
        // 주거유형별 인테리어 뷰
        path: "/portfolio/resident/:_portfolio",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/resident-view.vue"),
        props: true,
    },
    {
        // 공간별 인테리어 리스트
        path: "/portfolio/space",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/space-list.vue"),
        props: true,
    },
    {
        // 상업공간 인테리어 리스트
        path: "/portfolio/industry",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/industry-list.vue"),
        props: true,
    },
    {
        // 상업공간 인테리어 뷰
        path: "/portfolio/industry/:_portfolio",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/industry-view.vue"),
        props: true,
    },
    {
        // 부분시공 인테리어 리스트
        path: "/portfolio/partial",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/partial-list.vue"),
        props: true,
    },
    {
        // 부분시공 인테리어 뷰
        path: "/portfolio/partial/:_portfolio",
        component: () => import(/* webpackChunkName: "portfolio" */ "../pages/client/portfolio/partial-view.vue"),
        props: true,
    },
    {
        path: "/partners/reassurance",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/ReassuranceList.vue"),
        props: true,
    },
    {
        path: "/partners/reassurance/:_company",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/ReassuranceView.vue"),
        props: true,
    },
    {
        path: "/partners/interior",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/InteriorList.vue"),
        props: true,
    },
    {
        path: "/partners/interior/:_company",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/InteriorView.vue"),
        props: true,
    },
    {
        path: "/partners/partial-interior",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/PartialList.vue"),
        props: true,
    },
    {
        path: "/partners/partial-interior/:_company",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/PartialView.vue"),
        props: true,
    },
    {
        path: "/partners/technicians",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/TechnicianList.vue"),
        props: true,
    },
    {
        path: "/partners/technicians/:_technician",
        component: () => import(/* webpackChunkName: "portners" */ "../pages/client/partners/TechnicianView.vue"),
        props: true,
    },
    {
        // 견적문의
        path: "/estimate/estimate-inquiry",
        component: () => import("../pages/client/estimate/estimate-inquiry.vue"),
        props: true,
    },
    {
        // 견적문의
        path: "/estimate/inquiry/:_inquiry",
        component: () => import("../pages/client/estimate/InquiryViewPage.vue"),
        props: true,
    },
    {
        // 쇼핑몰 메인
        path: "/shop",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-main.vue"),
        props: true,
    },
    {
        // 쇼핑몰 상품 리스트 (카테고리별)
        path: "/shop/categories",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-list.vue"),
        props: true,
    },
    {
        // 쇼핑몰 상품 리스트 (카테고리별)
        path: "/shop/categories/:_category",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-list.vue"),
        props: true,
    },
    {
        // 쇼핑몰 상품 리스트 (스토어별)
        path: "/shop/stores/:_store",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-list.vue"),
        props: true,
    },
    {
        // 쇼핑몰 상품 리스트 (스토어-카테고리별)
        path: "/shop/stores/:_store/:_category",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-list.vue"),
        props: true,
    },
    {
        // 상품 뷰
        path: "/shop/products/:_product",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/product-view.vue"),
        props: true,
    },
    {
        // 브랜드 목록
        path: "/shop/brand-list",
        component: () => import(/* webpackChunkName: "brand-market" */ "../pages/client/shop/brand-list.vue"),
        props: true,
    },
    {
        // 브랜드 마켓
        path: "/shop/brand-market/:brandCode",
        component: () => import(/* webpackChunkName: "brand-market" */ "../pages/client/shop/brand-market.vue"),
        props: true,
    },
    {
        // 상품 - 베스트
        path: "/shop/best/",
        component: () => import(/* webpackChunkName: "shop-best" */ "../pages/client/shop/product-best.vue"),
        props: true,
    },
    {
        // 상품 - 핫딜
        path: "/shop/hot/",
        component: () => import(/* webpackChunkName:"shop-hot" */ "../pages/client/shop/product-hot.vue"),
        props: true,
    },
    {
        // 상품 - 이벤트
        path: "/shop/event/",
        component: () => import(/* webpackChunkName: "shop-event" */ "../pages/client/shop/product-event.vue"),
        props: true,
    },
    {
        // 상품 - 이벤트
        path: "/shop/event/:_board",
        component: () => import(/* webpackChunkName: "shop-event" */ "../pages/client/shop/product-event.vue"),
        props: true,
    },
    {
        // 상품 - 기획전
        path: "/shop/exhibition/",
        component: () => import(/* webpackChunkName: "shop-exhibition" */ "../pages/client/shop/product-exhibition.vue"),
        props: true,
    },
    {
        // 주문
        path: "/shop/order",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/order.vue"),
        props: true,
    },
    {
        // 주문완료
        path: "/shop/purchase",
        component: () => import(/* webpackChunkName: "shop" */ "../pages/client/shop/purchase.vue"),
        props: true,
    },
    {
        // 로그인
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
        props: true,
    },
    {
        // 비밀번호 찾기
        path: "/login/find-password",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
        props: true,
    },
    {
        // 아이디 찾기
        path: "/login/find-id",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
        props: true,
    },
    {
        // SNS 로그인 검증
        path: "/login/sns-validate",
        component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/sns-validate.vue"),
        props: true,
    },
    {
        // 회원가입 폼선택
        path: "/join/type",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
        props: true,
    },
    {
        // 회원가입
        path: "/join",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
        props: true,
    },
    {
        // 회원가입 폼
        path: "/join/form",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
        props: true,
    },
    {
        // 회원가입 완료
        path: "/join/complete",
        component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
        props: true,
    },
    {
        // 장바구니
        path: "/mypage/cart",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/cart.vue"),
        props: true,
    },
    {
        // 주문내역
        path: "/mypage/order-list",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/order-list.vue"),
        props: true,
    },
    {
        // 취소
        path: "/mypage/order-cancel",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/order-cancel.vue"),
        props: true,
    },
    {
        // 교환
        path: "/mypage/order-exchange",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/order-exchange.vue"),
        props: true,
    },
    {
        // 반품
        path: "/mypage/order-return",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/order-return.vue"),
        props: true,
    },
    {
        // 쿠폰함
        path: "/mypage/coupon",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/coupon.vue"),
        props: true,
    },
    {
        // 포인트
        path: "/mypage/point",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/point.vue"),
        props: true,
    },
    {
        // 상품 문의
        path: "/mypage/inquiry",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/inquiry.vue"),
        props: true,
    },
    {
        // 1:1 문의
        path: "/mypage/question",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/question.vue"),
        props: true,
    },
    {
        // 회원 정보 변경
        path: "/mypage/myinfo",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
        props: true,
    },
    {
        // 회원 탈퇴
        path: "/mypage/leave",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
        props: true,
    },
    {
        // 견적신청목록
        path: "/mypage/bookmarks",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/bookmarks.vue"),
        props: true,
    },
    {
        // 견적신청목록
        path: "/mypage/estimate",
        component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/estimate.vue"),
        props: true,
    },
    {
        // FAQ
        path: "/center/faq",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 개인정보처리방침
        path: "/center/privacy",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/privacy.vue"),
        props: true,
    },
    {
        // 이용약관
        path: "/center/terms",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/terms.vue"),
        props: true,
    },
    {
        // 이메일무단수집거부
        path: "/center/email-policy",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/email-policy.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 이쁜 집 자랑
        path: "/community/house",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/house.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 이쁜 집 자랑
        path: "/community/house/:_board",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/house.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 시공후기
        path: "/community/review",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/review.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 시공후기
        path: "/community/review/:_board",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/review.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 투명견적서
        path: "/community/estimate",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/estimate.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 투명견적서
        path: "/community/estimate/:_board",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/estimate.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 이벤트
        path: "/community/event",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/event.vue"),
        props: true,
    },
    {
        // 커뮤니티 - 이벤트
        path: "/community/event/:_board",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/community/event.vue"),
        props: true,
    },
    {
        // 검색 - 기본
        path: "/search/all",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/All.vue"),
        props: true,
    },
    {
        // 검색 - 주거공간
        path: "/search/resident",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Resident.vue"),
        props: true,
    },
    {
        // 검색 - 상업공간
        path: "/search/industry",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Industry.vue"),
        props: true,
    },
    {
        // 검색 - 부분시공
        path: "/search/partial",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Partial.vue"),
        props: true,
    },
    {
        // 검색 - 파트너스
        path: "/search/partners",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Partners.vue"),
        props: true,
    },
    {
        // 검색 - 이쁜 집 자랑
        path: "/search/house",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/House.vue"),
        props: true,
    },
    {
        // 검색 - 시공후기
        path: "/search/review",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Review.vue"),
        props: true,
    },
    {
        // 검색 - 스토어
        path: "/search/store",
        component: () => import(/* webpackChunkName: "community" */ "../pages/client/search/Store.vue"),
        props: true,
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console", "company", "technician", "measurer"],
    },
    {
        // 관리자 - 대시보드
        path: "/console/dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
        props: true,
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/boards/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/boards/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/boards/BoardView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/users/levels/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/users/withdrawals/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/users/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/users/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품관리
        path: "/console/shop/products",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/products/ProductList.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 생성
        path: "/console/shop/products/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/products/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 복사
        path: "/console/shop/products/copy",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/products/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 view
        path: "/console/shop/products/:_product",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/products/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 카테고리 관리
        path: "/console/shop/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/categories/CategoryList.vue"),
        props: true,
    },
    {
        // 관리자 - 전시 관리
        path: "/console/shop/exhibition",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/exhibition/ExhibitionView.vue"),
        props: true,
    },
    {
        // 관리자 - 브랜드 관리
        path: "/console/shop/brands",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/brands/BrandList.vue"),
        props: true,
    },
    {
        // 관리자 - 브랜드 관리 create
        path: "/console/shop/brands/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/brands/BrandView.vue"),
        props: true,
    },
    {
        // 관리자 - 브랜드 관리 view
        path: "/console/shop/brands/:_brand",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/brands/BrandView.vue"),
        props: true,
    },
    {
        // 관리자 - 통계관리
        path: "/console/statistics",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/statistics/StatisticsView.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/PurchaseList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/nonpayment",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/NonpaymentList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/payment",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/PaymentList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/delivery",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/DeliveryList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/cancel",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/CancelList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/exchange",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/ExchangeList.vue"),
        props: true,
    },
    {
        // 관리자 - 주문관리
        path: "/console/shop/purchases/return",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/purchases/ReturnList.vue"),
        props: true,
    },
    {
        // 관리자 - 정산관리
        path: "/console/shop/settlements",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/settlements/SettlementListPage.vue"),
        props: true,
    },
    {
        // 관리자 - 정산관리
        path: "/console/shop/settlements/:_settlement",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/settlements/SettlementViewPage.vue"),
        props: true,
    },
    {
        // 관리자 - 쿠폰 관리
        path: "/console/shop/coupons",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/coupons/CouponList.vue"),
        props: true,
    },
    {
        // 관리자 - 쿠폰 관리 create
        path: "/console/shop/coupons/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/coupons/CouponView.vue"),
        props: true,
    },
    {
        // 관리자 - 쿠폰 관리 view
        path: "/console/shop/coupons/:_coupon",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/coupons/CouponView.vue"),
        props: true,
    },
    {
        // 관리자 - 쿠폰 관리
        path: "/console/shop/points",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/points/PointList.vue"),
        props: true,
    },
    {
        // 관리자 - 상품문의
        path: "/console/shop/inquires",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/inquires/InquireList.vue"),
        props: true,
    },
    {
        // 관리자 - 구매후기
        path: "/console/shop/reviews",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/reviews/ReviewList.vue"),
        props: true,
    },
    {
        // 관리자 - 운영정보설정
        path: "/console/shop/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 견적신청목록
        path: "/console/estimate/inquiries/",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/estimate/InquiryList.vue"),
        props: true,
        scope: ["console", "interior", "measurer"],
    },
    {
        // 관리자 - 견적신청문서
        path: "/console/estimate/inquiries/:_inquiry",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/estimate/InquiryView.vue"),
        props: true,
        scope: ["console", "interior", "measurer"],
    },
    {
        // 관리자 - 안심계약목록
        path: "/console/contracts/",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/contracts/ContractList.vue"),
        props: true,
        scope: ["console", "interior"],
    },
    {
        // 관리자 - 안심계약문서
        path: "/console/contracts/write",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/contracts/ContractView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 안심계약문서
        path: "/console/contracts/:_contract",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/contracts/ContractView.vue"),
        props: true,
        scope: ["console", "interior"],
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/notifications/NotificationList.vue"),
        props: true,
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/faqs/FaqList.vue"),
        props: true,
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/questions/QuestionList.vue"),
        props: true,
    },
    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/trems/TermList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너관리
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banners/BannerList.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업관리
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popups/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업관리
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 문자·알림톡 관리
        path: "/console/messages",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/messages/MessagesView.vue"),
        props: true,
    },
    {
        path: "/console/portfolio",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/portfolio/portfolio-list.vue"),
        props: true,
    },
    {
        path: "/console/portfolio/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/portfolio/portfolio-view.vue"),
        props: true,
    },
    {
        path: "/console/portfolio/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/portfolio/category-list.vue"),
        props: true,
    },
    {
        path: "/console/portfolio/before-after",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/portfolio/before-after.vue"),
        props: true,
    },
    {
        path: "/console/portfolio/:_portfolio",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/portfolio/portfolio-view.vue"),
        props: true,
    },
    {
        path: "/console/company",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/company/CompanyList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        path: "/console/company/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/company/CompanyView.vue"),
        props: true,
    },
    {
        path: "/console/technicians",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/technician/TechnicianList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        path: "/console/technicians/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/technician/TechnicianView.vue"),
        props: true,
        scope: ["console", "technician"],
    },
    {
        // 콘솔 - 실측기술자 관리
        path: "/console/measurers",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/measurer/MeasurerList.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 콘솔 - 실측기술자 상세
        path: "/console/measurers/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/measurer/MeasurerView.vue"),
        props: true,
        scope: ["console"],
    },
    {
        path: "/console/portfolio/admin",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    try {
        var route = routes.find((route) => route.name == to.name);
        if (!route) throw new Error("해당 페이지가 존재하지 않습니다");

        var accessToken = sessionStorage.getItem("accessToken");
        if (accessToken) axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

        if (!route.scope) next();
        else {
            if (!accessToken) {
                if (0 <= to.path.indexOf("console")) {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            var payload = JSON.parse(atob(accessToken.split(".")[1]));
            var scope = payload.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = routes.find((route) => route.path == from.path)?.path ?? routes.find((route) => route.path == "/")?.path ?? "about:blank";
    }
});

export default router;
